import { forwardRef, SVGProps } from 'react';
import LogoOrishia from '../commons/LogoOrishia/index.tsx';
type LogoProps = Omit<SVGProps<SVGSVGElement>, 'src'>;

// const cdn = 'https://cdn.lugc.link/bfee34cd-2036-41db-91e8-8c16a7a1e4a8/-/preview/181x53/-/format/auto/'
// https://statics.helpia.com/landing/helpia-logo.svg
// eslint-disable-next-line  @typescript-eslint/no-explicit-any
const Logo = forwardRef<any, LogoProps>(({ ...props }, ref) => {
  //return <img alt="Helpia-Index" ref={ref} src={LogoHelpia} {...props} />;

  return <LogoOrishia ref={ref} {...props} />;
});

export default Logo;

/*import React from "react"

type LogoProps = Omit<React.ImgHTMLAttributes<HTMLImageElement>, "src">

const Logo = React.forwardRef<HTMLImageElement, LogoProps>(({ ...props }, ref) => {
  return <img alt="Helpia-Index" ref={ref} src={"https://statics.helpia.com/landing/helpia-logo.svg"} {...props} />
})

export default Logo*/
